import { StyledInfoSectionInfoContainer, StyledInfoSectionMainLabel, StyledInfoSectionSubTitleText, StyledInfoSectionAskToggle, StyledInfoSectionMainText, StyledInfoSectionTooltipContainer } from './styles';
import UpgradeToProChip from 'components/shareable/UpgradeToProChip';
import Sty, { SymphonyTooltip } from 'modules/Sty';
import useCurrentBrand from 'Hooks/useCurrentBrand';
import SwitchSymphony from 'elements/SwitchSymphony';
import { CSSProperties } from 'react';

interface InfoSectionProps {
    mainText: string;
    descriptionText?: string;
    requiresPro?: boolean;
    requiresPaid?: boolean;
    boostEnabled: boolean;
    showBorderTop?: boolean;
    showBorderBottom?: boolean;
    tooltipText?: string;
    tooltipIcon?: string;
    onChange: (ev: any) => void;
    tooltipOnClick?: () => void;
}

const BoostOption = ({
    mainText,
    descriptionText,
    requiresPro = false,
    requiresPaid = false,
    boostEnabled,
    tooltipText,
    tooltipIcon,
    showBorderBottom,
    showBorderTop,
    onChange,
    tooltipOnClick,
}: InfoSectionProps) => {
    const { isPaidBrand } = useCurrentBrand();

    const renderBoostTitleSection = () => {
        return (
            <div className="boostOptionMainTextContainer" style={sty.boostOptionMainTextContainer}>
                <div
                    className="boostOptionMainText"
                    style={Sty.text18bold}
                >
                    {mainText}
                </div>
                {tooltipText && tooltipIcon && tooltipOnClick &&
                    <button className="ml-1.5 w-6 h-6"
                        onClick={tooltipOnClick}>
                        <SymphonyTooltip
                            className="block w-6 h-6 cursor-pointer"
                            title={tooltipText}
                            arrow
                        >
                            <img
                                className="w-6 h-6"
                                alt="question-mark-icon.svg"
                                src={tooltipIcon}
                            />
                        </SymphonyTooltip>
                    </button>
                }
                {requiresPro &&
                    <div className="ml-1">
                        <UpgradeToProChip
                            className="boostOptionProChip"
                            type="gem"
                            color="purple"
                            height={20}
                            width={20}
                        />
                    </div>
                }
            </div>
        )
    }

    const renderBoostDescription = () => {
        return (
            <div
                className="boostOptionDescription"
                style={Sty.text16grey}
            >
                {descriptionText}
            </div>
        )
    }

    return (
        <div
            className="boostOptionComponent"
            style={sty.boostOptionComponent}
        >
            <StyledInfoSectionMainLabel>
                {renderBoostTitleSection()}
                {renderBoostDescription()}
            </StyledInfoSectionMainLabel>

            <SwitchSymphony
                className="boostOptionSwitch"
                checked={(requiresPro || requiresPaid) ? ((isPaidBrand) ? boostEnabled : false) : boostEnabled}
                onChange={onChange}
                style={{ marginLeft: 'auto' }}
            />
        </div>
    );
};

const sty: Record<string, CSSProperties> = {
    boostOptionComponent: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    boostOptionMainTextContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    }
}

export default BoostOption;
